import type {Inlet, Outlet} from "#template/runtime-graph/slots"
import {NotReady} from "#template/runtime-graph/slots"
import type {NodeClassImpl} from "#template/runtime-graph/types"
import {TypeDescriptors} from "#template/runtime-graph/type-descriptors"

const TD = TypeDescriptors

const getFieldDescriptor = {
    input: TD.inlet(TD.ShallowJSON()),
    key: TD.inlet(TD.Identity<any>()),
    output: TD.outlet(TD.Identity<any>()),
}

export class GetField<T> implements NodeClassImpl<typeof getFieldDescriptor, typeof GetField> {
    static descriptor = getFieldDescriptor
    static uniqueName = "GetField"
    input!: Inlet<T>
    key!: Inlet<keyof T>
    output!: Outlet<any>

    run() {
        if (this.input === NotReady || this.key === NotReady) {
            this.output.emitIfChanged(NotReady)
            return
        }
        const value = this.input?.[this.key]
        this.output.emitIfChanged(value)
    }
}
